import { render, staticRenderFns } from "./RegisteredRule.vue?vue&type=template&id=37e510a1&"
import script from "./RegisteredRule.vue?vue&type=script&lang=js&"
export * from "./RegisteredRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports